import * as React from 'react';

import styles from './pageNotFound.module.scss';

// eslint-disable-next-line react/prefer-stateless-function
export class PageNotFound extends React.Component {
  public render() {
    return <div className={styles.pageNotFound}>Error 404 - Page Not Found</div>;
  }
}
